import { SCROLL_THRESHOLD } from './constants';

export const validateMainCondition = (container: HTMLElement) => {
  const scrollSpaceLeftOnTheBottom =
    container.scrollHeight - container.scrollTop - container.offsetHeight;
  return scrollSpaceLeftOnTheBottom - SCROLL_THRESHOLD <= 0;
};
